module.exports = __webpack_public_path__ + "img/login-logo.c7824c8b.png";